import { render, staticRenderFns } from "./addMicroShopGoods.vue?vue&type=template&id=2e7ce045&scoped=true&"
import script from "./addMicroShopGoods.vue?vue&type=script&lang=js&"
export * from "./addMicroShopGoods.vue?vue&type=script&lang=js&"
import style0 from "./addMicroShopGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addMicroShopGoods.vue?vue&type=style&index=1&id=2e7ce045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ce045",
  null
  
)

component.options.__file = "addMicroShopGoods.vue"
export default component.exports